import React from 'react';
import { createHashRouter } from 'react-router-dom';
import NotFoundPage from '@/components/NotFoundPage';
import lazy from '@/utils/lazy';
import DefaultLayout from '@/layout/DefaultLayout';
import PasswordLogin from '@/pages/Login/PasswordLogin';
import LoginEvent, { BackToHome, LoginSuccess, LogoutSuccess, NeedLogin } from '@/events/login-event';
import { createRoute } from '@/utils/create-route';

export const router = createHashRouter(createRoute([
  {
    path: '/',
    element: <DefaultLayout/>,
    errorElement: <NotFoundPage/>,
    children: [
      {
        path: '/',
        element: lazy(async () => import('@/pages/Home').then(m => m.default)),
        auth: false,
      },
      {
        path: '/system/menu',
        element: lazy(async () => import('@/pages/System/Menu/List').then(m => m.default)),
        auth: 'sys.menu.view',
      },
      {
        path: '/system/role',
        element: lazy(async () => import('@/pages/System/Role/List').then(m => m.default)),
        auth: 'sys.role.view',
      },
      {
        path: '/system/user',
        element: lazy(async () => import('@/pages/System/User/List').then(m => m.default)),
        auth: 'sys.user.view',
      },
      {
        path: '/system/log',
        element: lazy(async () => import('@/pages/System/Log/List').then(m => m.default)),
        auth: 'sys.log.view',
      },
      {
        path: '/center/node',
        element: lazy(async () => import('@/pages/Center/Node/List').then(m => m.default)),
        auth: 'center.node.view',
      },
      {
        path: '/customer/customer',
        element: lazy(async () => import('@/pages/Customer/Customer/List').then(m => m.default)),
        auth: 'customer.customer.view',
      },
      {
        path: '/customer/insurance',
        element: lazy(async () => import('@/pages/Customer/Insurance/List').then(m => m.default)),
        auth: 'customer.insurance.view',
      },
      {
        path: '/device/device',
        element: lazy(async () => import('@/pages/Device/Device/List').then(m => m.default)),
        auth: 'device.device.view',
      },
      {
        path: '/video',
        element: lazy(async () => import('@/pages/Video/View').then(m => m.default)),
        auth: 'video.view',
      },
    ],
  },
  {
    path: '/login',
    element: <PasswordLogin/>,
  },
]));

// 登录成功回跳地址
let prevRoute: string | null = null;
const needLoginEventHandler = () => {
  if (prevRoute === null) {
    prevRoute = window.location.href;
  }
  router.navigate('/login', {
    replace: true,
  });
};
const loginSuccessEventHandler = () => {
  if (prevRoute !== null && !prevRoute.includes('/login')) {
    window.location.href = prevRoute;
    prevRoute = null;
  } else {
    router.navigate('/', {
      replace: true,
    });
  }
};
const logoutSuccessEventHandler = () => {
  router.navigate('/login');
};
const backToHomeEventHandler = () => {
  router.navigate('/');
};
LoginEvent.on(NeedLogin, needLoginEventHandler);
LoginEvent.on(LoginSuccess, loginSuccessEventHandler);
LoginEvent.on(LogoutSuccess, logoutSuccessEventHandler);
LoginEvent.on(BackToHome, backToHomeEventHandler);
